import { Quota } from '../../features/quotas/models/quota.interface';

export interface QuotaSummary {
  meatTypeName: string;
  totalLimitTons: number;
}

export interface QuotaState {
  quotas: Quota[];
  summary: QuotaSummary[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const initialQuotaState: QuotaState = {
  quotas: [],
  summary: [],
  loading: false,
  loaded: false,
  error: null
};
